export const NAME = 'dashboard-todaysUrgencies';

export const productDomains = {
	POV: 'POV',
	HAV: 'HAV',
	SME: 'SME',
	ONZP: 'ONZP',
	ZP: 'ZP',
};

export const productDomainsIdsMapper = {
	POV: 4,
	HAV: 5,
	SME: 6,
	ONZP: 3,
	ZP: 1,
};
